import { Component, Input, OnInit, Inject } from 'ng-metadata/core';

import './content-document-placeholder.component.scss';

@Component({
    selector: 'mw-content-document-placeholder',
    template: `
        <div class="mw-content-document-placeholder mw-content-document-placeholder--{{$ctrl.displayMode}}" ng-class="{'mw-content-document-placeholder--selectable': $ctrl.isSelectable}">
            <!-- <img ng-if="!$ctrl.isAvatarPaddingOn" class="mw-content-document-placeholder__img" ng-src="{{$ctrl.assetsPath + 'icons/meltwater-icons/content-document-placeholder.svg'}}" />
            <img ng-if="$ctrl.isAvatarPaddingOn" ng-src="{{$ctrl.assetsPath + 'icons/meltwater-icons/content-document-placeholder-padding.svg'}}" /> -->
            <div class="mw-content-document-placeholder__img">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 680 125">
                    <mask id="mw-content-document-placeholder__mask{{::$ctrl.id}}" x="0" y="0" width="680" height="125">
                        <rect x="0" y="0" width="680" height="125" fill="white"></rect>
                        <g>
                            <circle cx="20" cy="20" r="20"></circle>
                            <rect x="55" y="2" width="150" height="12" rx="6" ry="6"></rect>
                            <rect x="55" y="24" width="100" height="12" rx="6" ry="6"></rect>
                        </g>
                        <g class="content">
                            <rect x="0" y="64" height="12" width="550" rx="6" ry="6"></rect>
                            <rect x="0" y="88" height="12" width="550" rx="6" ry="6"></rect>
                            <rect x="0" y="112" height="12" width="320" rx="6" ry="6"></rect>
                        </g>
                    </mask>
                    <rect x="0" y="0" fill="white" style="mask: url(#mw-content-document-placeholder__mask{{::$ctrl.id}});" width="680" height="130"></rect>
                </svg>
                <!-- <svg viewBox="-10 -10 120 120">
                  <mask id="myMask">
                    <rect x="0" y="0" width="100" height="100" fill="white" />
                    <path d="M10,35 A20,20,0,0,1,50,35 A20,20,0,0,1,90,35 Q90,65,50,95 Q10,65,10,35 Z" fill="black" />
                  </mask>
                 
                  <polygon points="-10,110 110,110 110,-10" fill="orange" />

                  <circle cx="50" cy="50" r="50" style="mask: url(#myMask)" />
                </svg> -->
            </div>

            <div class="mw-content-document-placeholder__mask-background"></div>
        </div>
    `
})
export class ContentDocumentPlaceholderComponent implements OnInit {
    @Input('<') isSelectable: boolean;
    @Input('<') isAvatarPaddingOn: boolean;
    @Input('<') displayMode: string; // Supported values 'standard'(default), 'compact', mini', 'list', 'indy'
    private id: string;
    private assetsPath = process.env.assetsPath || '/'

    constructor(
        @Inject('$scope') private $scope
    ) {
        'ngInject';
    }

    ngOnInit() {
        this.isSelectable = this.isSelectable === false ? false : true;
        this.displayMode = this.displayMode ? this.displayMode : 'standard';
        this.id = this.$scope.$id;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/placeholder/content-document-placeholder.component.ts